import Http from '@/services/index.js'
import Model from '@/services/Model.js'

class DigitalAccounts extends Model {
  constructor() {
    super('/digital_accounts/')
  }

  getHistory(id, query = '') {
    return Http.get(`${this.model}${id}/historic/${query}`)
  }

  generateOfx(startDate, endDate, accountId, email, config = {}) {
    return Http.post(
      `${this.model}generate_ofx/`,
      {
        start_date: startDate,
        end_date: endDate,
        digital_account: accountId,
        email,
      },
      config,
    )
  }

  statement(payload, query = '', config = {}) {
    return Http.post(`${this.model}statement/${query}`, payload, config)
  }

  statementSummary(payload, query = '', config = {}) {
    return Http.post(`${this.model}statement_summary/${query}`, payload, config)
  }

  downloadStatementPdf(payload, query = '') {
    return Http.post(`${this.model}statement_pdf/${query}`, payload)
  }

  downloadStatementSummaryPdf(payload) {
    return Http.post(`${this.model}statement_summary_pdf/`, payload)
  }
}

export default new DigitalAccounts()
